import ContainerView from "./ContainerView";
import { Landing } from "components";

export const ContactContainer = () => {
  return (
    <Landing>
      <ContainerView />
    </Landing>
  );
};
